import type { FAQItem, ResourcePageSeo } from "../resource-seo";

export const faqs: FAQItem[] = [
  {
    question: "What do Salary Insights show?",
    answer:
      "Pay ranges for a job title by experience level and city, shown as low, median and high, plus how base pay, bonus and equity typically split for that role.",
  },
  {
    question: "Where does the salary data come from?",
    answer:
      "Ranges are built from recent job postings that list pay and from offers shared by MindMyJob users. Each range shows how many data points it is based on, so you can judge how reliable it is.",
  },
  {
    question: "How do I know if my offer is fair?",
    answer:
      "Enter the role, city, experience and offered base pay. You will see which percentile the offer falls in, the median for that role and how much room there usually is to negotiate.",
  },
  {
    question: "Should I share my current salary with a recruiter?",
    answer:
      "You don't have to. Anchoring on the market range for the new role usually leads to a better offer than anchoring on your current pay. The negotiation scripts show how to say this politely.",
  },
  {
    question: "What is total compensation?",
    answer:
      "Everything you are paid in a year: base salary, performance bonus, the yearly value of equity, and one-off payments such as a joining bonus. Comparing total compensation over four years gives a fairer picture than comparing base pay alone.",
  },
  {
    question: "Can I compare two job offers?",
    answer:
      "Yes. Add each offer's base, bonus, equity and joining bonus, and the comparison shows year-by-year and four-year totals side by side.",
  },
  {
    question: "Are Salary Insights free?",
    answer:
      "You can look up salary ranges for free. Offer checks and offer comparisons need a free MindMyJob account.",
  },
];

export const seo: ResourcePageSeo = {
  slug: "salary-insights",
  name: "Salary Insights",
  title: "Salary Insights by Role, Level and City | MindMyJob",
  description:
    "See salary ranges by role, experience and city, check if an offer is fair, compare total pay over four years and get scripts to negotiate.",
  keywords: [
    "salary insights",
    "salary by role and city",
    "software engineer salary bengaluru",
    "product manager salary india",
    "is my job offer fair",
    "salary negotiation",
    "total compensation calculator",
    "compare job offers",
    "salary range by experience",
    "ctc negotiation tips",
  ],
  ogImage: "/assets/images/resources/salary-insights/hero-salary-ranges.png",
  ogImageAlt:
    "MindMyJob Salary Insights showing a salary range by level for a Product Manager in Bengaluru",
  featureList: [
    "Salary ranges by role, level and city",
    "Offer check with percentile",
    "Base, bonus and equity breakdown",
    "Four-year total compensation view",
    "Side-by-side offer comparison",
    "Negotiation scripts",
  ],
  faqs,
};
